import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-stack-line text-xl text-background-50"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
              久久综合
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl text-foreground-800`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={`${cat.icon} text-lg`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className="ri-information-line text-lg"></i>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}